import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux/store';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { Suspense } from 'react';
import { PersistGate } from 'redux-persist/integration/react';
import Loader from './components/Loader/Loader';
import React from 'react';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Suspense fallback={<Loader/>} >
    <Provider store={store.store}>
    <PersistGate loading={null} persistor={store.persistor}>
      <Router>
        <App />
      </Router>
      </PersistGate>
    </Provider>,
  </Suspense>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();